import * as yup from "yup";

export const RecoveryPasswordValidation = yup.object().shape({
	password: yup.string().required("Password is required"),
	confirmPassword: yup
		.string()
		.required("Password is required")
		.oneOf([yup.ref("password"), null], "Passwords must match")
});
